import React from 'react';
import {useTranslation} from "react-i18next";

const NotFoundPage: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="h-screen flex flex-col items-center justify-center">
            <div className="text-center">
                <h1 className="text-6xl font-extrabold text-gray-800">404</h1>
                <p className="text-2xl font-semibold text-gray-600">{t('pageNotFound')}</p>
                <p className="mt-2 text-gray-500">{t('pageNotFoundDescription')}</p>
            </div>
        </div>
    );
};

export default NotFoundPage;
